import { findTagById } from "@/service/structure.js";
export default {
  name: "position-structure-add",
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    row: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      detail: {}
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    _tagTarget() {
      if (this.detail.tagTarget === "ORG") {
        // lg: 部门
        return $t("pgxs2", "部门");
      } else if (this.detail.tagTarget === "USER") {
        // lg: 用户
        return $t("kgsv2", "用户");
      } else {
        // lg: 全部
        return $t("en402", "全部");
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.getDetail();
      }
    }
  },
  methods: {
    close() {
      this.detail = {};
      this.visible = false;
    },
    async getDetail() {
      const params = {
        id: this.row.id
      };
      this.loading = true;
      let res = await findTagById(params);
      this.loading = false;
      if (res.data && res.data.result === 0) {
        this.detail = res.data.retVal;
      }
    }
  }
};